// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vertLine_12AR6{transform-origin:center;transition:opacity .3s,transform .3s}.hidden_1tEDm{opacity:0;transform:rotate(90deg)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vertLine": "vertLine_12AR6",
	"hidden": "hidden_1tEDm"
};
module.exports = ___CSS_LOADER_EXPORT___;
